import { render, staticRenderFns } from "./CourseAddEditPersonInviteModal.vue?vue&type=template&id=24c51d8a&"
import script from "./CourseAddEditPersonInviteModal.vue?vue&type=script&lang=ts&"
export * from "./CourseAddEditPersonInviteModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseAddEditPersonInviteModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VForm,VRow,VSelect,VTextField})
